import { render, staticRenderFns } from "./Tbody.vue?vue&type=template&id=2d64a7a0&"
import script from "./Tbody.vue?vue&type=script&lang=ts&"
export * from "./Tbody.vue?vue&type=script&lang=ts&"
import style0 from "./Tbody.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports